import Accordion from "./Accordion";

export default Accordion;
export type { AccordionProps, AccordionItem } from "./Accordion.d";
